import { API_VERSION, HOME_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_HOMES = `${HOME_SERVICE}/activities`;

export const activities = {
  create: async ({ data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_HOMES}`,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  materials: {
    get: async ({ planId, areaId, materialId }) => {
      const options = await apiOptions({
        url: `${API_HOMES}?refId=home-service/plans/${planId}/areas/${areaId}/materials/${materialId}`,
        method: "get",
        headers: { [X_API_VERSION]: API_VERSION },
      });
      return apiRequest(options);
    },
  },
  priceLevelAssigned: {
    get: async ({ accountId, filters }) => {
      const params = { refId: `account-service/accounts/${accountId}` };
      const options = await apiOptions({
        url: `${API_HOMES}`,
        method: "get",
        headers: { [X_API_VERSION]: API_VERSION },
        params,
        filters,
      });
      return apiRequest(options);
    },
  },
};
